
interface ServerDataResponse {
  id: number;
  name?: string;
  authToken?: string;
  secretKey?: string;
  url: string;
}

interface ServerConfigResponse {
  servers?: ServerDataResponse[];
  api: string;
  org_uid: string;
}

export const getServerConfig = async (data: ServerModel, url:string, apikey:string): Promise<ServerModel | undefined> => {

  try {
    const response: Response = await fetch(url + "/getData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Api-Key": apikey,
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      console.error("Error Saving ServerConfiguration");
    }

    const resp = await response.json() as ServerConfigResponse;
    const firstServer = resp.servers?.[0];

    return {
      secretKey: firstServer?.secretKey ?? "",
      authToken: firstServer?.authToken ?? "",
      api: resp.api,
      org_uid: resp.org_uid,
    };
  } catch (error) {
    console.error("Error Saving ServerConfiguration:", error);
  }
};

export const saveServerConfig = async (data: ServerModel, url:string, apikey:string): Promise<void> => {

  try {
    const response: Response = await fetch(url + "/Create", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Api-Key": apikey,
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      console.error("Error Saving ServerConfiguration");
    }
  } catch (error) {
    console.error("Error Saving ServerConfiguration:", error);
  }
};


export interface ServerModel {
  secretKey: string;
  authToken: string;
  api: string;
  org_uid: string;
}
